import React from 'react';

const TermsOfService = () => {
  return (
    <div className="max-w-3xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <p className="mb-4">By using our Jobber integration app ("the App"), you agree to the following terms:</p>

      <ol className="list-decimal ml-6 space-y-4">
        <li>
          <strong>Usage:</strong> You are responsible for all activity that occurs under your account. This App is intended for authorized Jobber users only.
        </li>
        <li>
          <strong>Data Handling:</strong> The App only reads and writes necessary data (clients, notes) to your Jobber account. No data is shared with third parties.
        </li>
        <li>
          <strong>Limitations:</strong> The App is provided "as-is" without warranties. We are not responsible for data loss or service outages.
        </li>
        <li>
          <strong>Modifications:</strong> We reserve the right to update or terminate the App at any time.
        </li>
        <li>
          <strong>Support:</strong> For help, contact us at <a href="mailto:hi@lsarespond.com" className="text-blue-600 underline">hi@lsarespond.com</a>.
        </li>
      </ol>

      <p className="mt-6 text-sm text-gray-500">Effective Date: May 2025</p>
    </div>
  );
};

export default TermsOfService;